import React from 'react';
import styled from 'astroturf/react';

import { Author } from 'js/liswp/Sidebar/hooks/types';

import AboutTheAuthors from './AboutTheAuthorsSection';

export type AboutTheAuthorsSSRProps = {
  authors: Author[];
  workId: number;
  workTitle?: string;
  workAuthorName?: string;
  workThumbnailUrl?: string;
  workYear?: number;
  workViewCount?: number;
};

type WorkContext = {
  workTitle?: string;
  workAuthorName?: string;
  workThumbnailUrl?: string;
  workYear?: number;
  workViewCount?: number;
};

const triggerLoginModal = async (
  author: Author,
  workId: number,
  action: 'follow' | 'message',
  workContext: WorkContext,
) => {
  const { openLoginModal } = await import('js/login_modal/LoginModalManager');

  const actionText = action === 'follow' ? 'follow' : 'message';
  const actionTextCapitalized = action === 'follow' ? 'Follow' : 'Message';

  // FIXME: Fix login modal copy
  openLoginModal({
    postLoginRedirectUrl: window.location.href,
    clickTrackingContext: {
      source: `loswp-about-authors-${actionText}-${workId}`,
      entityId: author.id,
    },
    configuredText: {
      buttonsPage: { header: `${actionTextCapitalized} ${author.displayName}` },
      emailEntryPage: {
        subheader: `Sign up or log in to ${actionText} this author.`,
      },
      emailLoginPage: { subheader: `Log in to ${actionText} this author.` },
      emailRegistrationPage: {
        subheader: `Sign up to ${actionText} this author.`,
      },
    },
    registrationParams: {
      user_source: actionText,
    },
    workTitle: workContext.workTitle,
    authorName: workContext.workAuthorName,
    workThumbnailUrl: workContext.workThumbnailUrl,
    workYear: workContext.workYear,
    workViewCount: workContext.workViewCount,
  });
};

const Wrapper = styled.div`
  @import 'stylesheets/design_system/breakpoint';

  padding-bottom: var(--spacing-sm-24, 24px);

  @include breakpoint(large) {
    padding-bottom: var(--spacing-md-40, 40px);
  }
`;

const AboutTheAuthorsSSR: React.FC<AboutTheAuthorsSSRProps> = ({
  authors,
  workId,
  workTitle,
  workAuthorName,
  workThumbnailUrl,
  workYear,
  workViewCount,
}) => {
  const workContext: WorkContext = {
    workTitle,
    workAuthorName,
    workThumbnailUrl,
    workYear,
    workViewCount,
  };

  const handleFollow = (author: Author) => {
    triggerLoginModal(author, workId, 'follow', workContext);
  };

  const handleMessage = (author: Author) => {
    triggerLoginModal(author, workId, 'message', workContext);
  };

  if (!authors || authors.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      <AboutTheAuthors
        authors={authors}
        onFollow={handleFollow}
        onMessage={handleMessage}
        showViewAllPapersLink={true}
      />
    </Wrapper>
  );
};

export default AboutTheAuthorsSSR;
